type ClassroomEventPayload = {
  scope?: string;
  classroomUuids?: string[];
  [key: string]: unknown;
};

export const createEventPayloads = <T extends ClassroomEventPayload>(payload: T): T[] => {
  if (payload.scope !== "CLASSROOM" || !payload.classroomUuids || payload.classroomUuids.length <= 1) {
    return [payload];
  }

  return payload.classroomUuids.map((classroomUuid) => ({
    ...payload,
    classroomUuids: [classroomUuid],
  }));
};
